import {createSelector} from 'reselect';
import WebLoyaltyVersion from '../../enums/WebLoyaltyVersion';
import {getSettings} from '../selectors/selectors';
import getWebLoyaltyCountryCode from './getWebLoyaltyCountryCode';

export default webLoyaltyVersion => createSelector(
  [getSettings, getWebLoyaltyCountryCode],
  (settings, countryCode) => {
    if (webLoyaltyVersion === WebLoyaltyVersion.WEBLOYALTY_MATCH && settings.web_loyalty_match && countryCode
      && settings.web_loyalty_match[countryCode.toLowerCase()]) {
      return settings.web_loyalty_match[countryCode.toLowerCase()];
    }
    
    if (settings.new_web_loyalty && countryCode && settings.new_web_loyalty[countryCode.toLowerCase()]) {
      return settings.new_web_loyalty[countryCode.toLowerCase()];
    }
    
    return ({});
  },
);
